module.exports = __webpack_public_path__ + "static/media/acerta-off-app-provider-icon.e087989b.svg";